import request from '../../axios';

export const deleteDocumentImg = async (imgGuid: string) => {
  const {data}: {data: {bank_validation: string}} = await request.delete(
    `/api/v2/payment/delete-loan-request-file/loan-request-file/` + imgGuid,
  );
  return data;
};
